import { render, staticRenderFns } from "./_SubscriptionLabel.vue?vue&type=template&id=442a27df"
import script from "./_SubscriptionLabel.vue?vue&type=script&lang=ts"
export * from "./_SubscriptionLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports